import { Component, EventEmitter, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-client-header',
  imports: [TranslateModule],
  templateUrl: './client-header.html',
  styleUrl: './client-header.scss',
})
export class ClientHeader {
  @Output() readonly createRequested = new EventEmitter<void>();

  requestCreate(): void {
    this.createRequested.emit();
  }
}
